import { createMemo, Accessor } from "solid-js";
import { CampaignTile } from "@/types/checkout";

export const useSelectionAlerts = (
  tiles: Accessor<CampaignTile[]>,
  adjustedMaxSelections: Accessor<number>,
) => {
  const hasReachedMaxBookings = createMemo(() => adjustedMaxSelections() === 0);

  const hasNoAvailableSlots = createMemo(() => {
    if (hasReachedMaxBookings()) return false;
    const unbookedTiles = tiles().filter((tile) => !tile.alreadyBooked);
    return unbookedTiles.every((tile) => tile.available === false);
  });

  const showSelectionAlert = createMemo(
    () => hasReachedMaxBookings() || hasNoAvailableSlots(),
  );

  const alertMessage = createMemo(() => {
    if (hasReachedMaxBookings()) {
      return "You have reached the maximum number of bookings for this window.";
    }
    if (hasNoAvailableSlots()) {
      return "All remaining time slots are unavailable.";
    }
    return "";
  });

  return {
    showSelectionAlert,
    alertMessage,
    hasReachedMaxBookings,
    hasNoAvailableSlots,
  };
};
